import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { EVisitorStatus } from 'modules/_common/consts/eVisitorStatus';
import { upsertCalculationGuest } from 'modules/accommodations/features/reservations/api';

export const useUpdateCalculationGuestMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast, warningToast } = useCustomToast();

  // Set unit attributes
  return useMutation(upsertCalculationGuest, {
    onSettled: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CALCULATION_GUESTS, {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CALCULATION_GUEST_DETAILS, {
        refetchInactive: true,
      });
      queryClient.refetchQueries(QUERY_KEYS.EVISITOR_GUESTS);
      queryClient.refetchQueries(QUERY_KEYS.LITE_CALCULATION_GUESTS);
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CALCULATION_GUESTS, {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CALCULATION_GUEST_DETAILS, {
        refetchInactive: true,
      });
      queryClient.refetchQueries(QUERY_KEYS.EVISITOR_GUESTS);
      queryClient.refetchQueries(QUERY_KEYS.LITE_CALCULATION_GUESTS);

      successToast(t('Guest details successfully updated.'));

      if (data?.eVisitorMessage?.length > 0) {
        if (
          variables.payload.guestCheckIn === true &&
          data?.eVisitorStatus === EVisitorStatus.PRIJAVLJEN
        ) {
          successToast(data?.eVisitorMessage);
        } else {
          warningToast(data?.eVisitorMessage);
        }
      }
    },
    onError: (res: any) => {
      const errorMessage = res?.response?.data?.ErrorDescription;

      errorToast(errorMessage);
    },
  });
};
